// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of ToolbarWidthsNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */
export enum ToolbarWidths {
	XXL = 610,
	XL = 540,
	L = 460,
	M = 450,
	S = 410,
}
